import {ref} from "@vue/composition-api";
import Inertia from "@inertiajs/inertia";

/**
 * Types copied from https://github.com/inertiajs/inertia/blob/master/packages/inertia-vue3/index.d.ts
 */

interface Form<Data> {
    errors: { [K in keyof Data]: string | undefined }
    hasErrors: boolean
    processing: boolean
    progress: ProgressEvent | null
    wasSuccessful: boolean
    recentlySuccessful: boolean

    data(): Data

    transform(callback: (data: Data) => object): this

    reset(...fields: (keyof Data)[]): this

    clearErrors(...fields: (keyof Data)[]): this

    serialize(): { errors: { [K in keyof Data]: string | undefined }, [key: string]: any }

    unserialize(data: object): this

    submit(method: string, url: string, options?: Inertia.VisitOptions): void

    get(url: string, options?: Inertia.VisitOptions): void

    post(url: string, options?: Inertia.VisitOptions): void

    put(url: string, options?: Inertia.VisitOptions): void

    patch(url: string, options?: Inertia.VisitOptions): void

    delete(url: string, options?: Inertia.VisitOptions): void
}

type FormWithData<Data> = Data & Form<Data>;

type InertiaWithForm = Inertia.Inertia & {
    form: Form<unknown>;
}

const localInertia = ref<null | InertiaWithForm>(null);

export const initInertia = (inertia: InertiaWithForm) => {
    localInertia.value = inertia;
}


/**
 *  @IMPORTANT: Do not use, it is hard to test. useFormHelper instead
 */
// export function useInertiaForm<Data>(data: Data): FormWithData<Data> {
//     if (localInertia.value === null) {
//         throw  new Error('Inertia was not initiated');
//     }
//     // @ts-ignore
//     return localInertia.value.form(data);
//     // return ref(Vue.prototype.$inertia.form(data));
// }

const getLocalInertia = (): InertiaWithForm => {
    if (localInertia.value === null) {
        throw  new Error('Inertia was not initiated');
    }
    return localInertia.value;
}

export function useInertia(): InertiaWithForm {
    return getLocalInertia();
}